import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=6bbcf7fa&scoped=true&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=6bbcf7fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbcf7fa",
  null
  
)

export default component.exports